import { render, staticRenderFns } from "./CollapseLabel.vue?vue&type=template&id=4bfb31a9"
import script from "./CollapseLabel.vue?vue&type=script&lang=js"
export * from "./CollapseLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports